import SignUpSlideshow from './SignUpSlideshow';

export default SignUpSlideshow;
